// Angular
import {AfterViewInit, Component, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
// Store
import {Store} from '@ngxs/store';
import {SetLogAcknowledge, SetReleaseNotes, UpdateAppStart} from '../../action/state.action';
// Model
import {BroadcastEventModel} from '../../model/broadcast-event.model';
import {ToasterType} from '../../model/toast-type.model';
import { ANIMATIONS, NotificationOptionsModel, FORMAT_TYPE } from '@cv-invision/cv.component-library.ux';
// Service
import {BroadcastService} from '../../service/broadcast.service';
import { ConfigService } from '../../service/config.service';
import { AppInformationService } from '../../service/app-info.service';

export const CLEAR_TOASTER_NOTIFICATION = 'CLEAR_TOASTER_NOTIFICATION';

enum NOTIFICATION_TYPE {
	SUCCESS,
	ERROR,
	WARNING,
	UPDATE_APP,
	NEW_RELEASE_LOG_APP,
	TOASTER
}

@Component({
	selector: 'cv-toaster',
	templateUrl: './toaster.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./toaster.component.scss']
})
export class ToasterComponent implements AfterViewInit {
	NOTIFICATION_TYPE = NOTIFICATION_TYPE;
	notifications: Array<{
		show: boolean;
		message?: string;
		autoClose?: boolean;
		options?: NotificationOptionsModel;
	}> = [];
	private lastUpdateEventNotification: any;
	public FORMAT_TYPE = FORMAT_TYPE;
	public openReleaseNotes = false;

	constructor(
		private broadcastService: BroadcastService,
		private store: Store,
		private router: Router,
		private configService: ConfigService,
		private appInfo: AppInformationService) {

		this.notifications[NOTIFICATION_TYPE.SUCCESS] = {
			show: false,
			message: '',
			autoClose: true
		};
		this.notifications[NOTIFICATION_TYPE.ERROR] = {
			show: false,
			message: '',
			autoClose: true
		};
		this.notifications[NOTIFICATION_TYPE.WARNING] = {
			show: false,
			message: '',
			autoClose: true
		};
		this.notifications[NOTIFICATION_TYPE.UPDATE_APP] = {
			show: false,
			message: '',
			autoClose: true
		};
		this.notifications[NOTIFICATION_TYPE.NEW_RELEASE_LOG_APP] = {
			show: false,
			message: '',
			autoClose: true
		};
		this.notifications[NOTIFICATION_TYPE.TOASTER] = {
			show: false,
			options: {
				title: 'Default Title, please modify',
				message: 'Default message, please modify',
				type: 'info',
				autoClose: true,
				fixed: true,
				animation: ANIMATIONS.BOTTOM_CENTER
			}
		};
		this.createToastNotification();
	}

	/**
	 * Hook
	 */
	ngAfterViewInit(): void {
		if (!this.appInfo.logAcknowledge) {
			// this.configService.getReleaseNotes().subscribe((payload: any) => {
			// 	const releaseNotesOf = payload.find((release: any) => {
			// 		return this.router.url.includes(release.system);
			// 	});
			// 	if (releaseNotesOf && releaseNotesOf.release[0]) {
			// 		this.store.dispatch(new SetReleaseNotes(releaseNotesOf.release[0],this.appInfo.appName));
			//
			// 		setTimeout(() => {
			// 			this.broadcastService.broadcast({
			// 				name: ToasterType.NEW_RELEASE_LOG_APP,
			// 				event: {}
			// 			});
			// 		});
			// 	}
			// });
		}
	}

	/**
	 * Shows Notification based on type.
	 * @param type
	 * @param message
	 */
	showNotification(type: NOTIFICATION_TYPE, message: string, autoClose = true): void {
		this.notifications[type].show = true;
		this.notifications[type].message = message;
		this.notifications[type].autoClose = autoClose;
	}

	/**
	 * Clears out and hides notification based on type.
	 * @param type
	 */
	clearNotification(type: NOTIFICATION_TYPE): void {
		this.notifications[type].show = false;
		this.notifications[type].message = '';
		this.notifications[type].autoClose = true;

		if (type === NOTIFICATION_TYPE.NEW_RELEASE_LOG_APP) {
			// If the Notification is a release log and the user manually close it
			this.store.dispatch(new SetLogAcknowledge(true,this.appInfo.appName));
		}
	}

	/**
	 * Set the list of Toast notification listeners
	 */
	private createToastNotification(): void {
		this.broadcastService.on(ToasterType.ERROR, (event: BroadcastEventModel) => {
			const autoClose = typeof(event.event.autoClose) !== 'undefined' ? event.event.autoClose : true;
			this.showNotification(NOTIFICATION_TYPE.ERROR, event.event.error || 'Error', autoClose);
		});
		this.broadcastService.on(ToasterType.SUCCESS, (event: BroadcastEventModel) => {
			const autoClose = typeof(event.event.autoClose) !== 'undefined' ? event.event.autoClose : true;
			this.showNotification(NOTIFICATION_TYPE.SUCCESS, event.event.message || 'Error', autoClose);
		});
		this.broadcastService.on(ToasterType.WARNING, (event: BroadcastEventModel) => {
			const autoClose = typeof(event.event.autoClose) !== 'undefined' ? event.event.autoClose : true;
			this.showNotification(NOTIFICATION_TYPE.WARNING, event.event.message || 'Error', autoClose);
		});
		this.broadcastService.on(ToasterType.UPDATE_APP, (event: BroadcastEventModel) => {
			this.lastUpdateEventNotification = event;
			this.showNotification(
				NOTIFICATION_TYPE.UPDATE_APP,
				'There is a new version of the application. Click here to refresh.'
			);
		});
		this.broadcastService.on(ToasterType.NEW_RELEASE_LOG_APP, (event: BroadcastEventModel) => {
			this.showNotification(
				NOTIFICATION_TYPE.NEW_RELEASE_LOG_APP,
				`<i class="fas fa-info-circle"></i> <strong>
						We have a new version of the application!</strong>
						<a>Click here</a> to know all the improvements`
			);
		});
		this.broadcastService.on(ToasterType.TOASTER, (event: BroadcastEventModel) => {
			Object.assign(this.notifications[NOTIFICATION_TYPE.TOASTER].options, event.event)
			this.showNotification(NOTIFICATION_TYPE.TOASTER, event.event.message || 'Error');
		});

		this.broadcastService.on(CLEAR_TOASTER_NOTIFICATION, (event: BroadcastEventModel) => {
			this.clearNotification(NOTIFICATION_TYPE.SUCCESS);
		});
	}

	/**
	 * If user click on the Update, send the last Event Update Notification
	 * @param event
	 */
	public onUpdateApplication(event: any): void {
		this.store
			.dispatch(new UpdateAppStart(this.lastUpdateEventNotification.event.version,this.appInfo.appName))
			.subscribe(() => {
				// Clear latest update request
				this.lastUpdateEventNotification = {};
				this.clearNotification(NOTIFICATION_TYPE.UPDATE_APP);
			});
	}

	/**
	 * Open and clear the notification for the Release Log
	 * @param event
	 */
	public onOpenReleaseNotes(event: any): void {
		this.openReleaseNotes = true;
		this.clearNotification(NOTIFICATION_TYPE.NEW_RELEASE_LOG_APP);
	}
}
